
webpack.register(
    'modules/the-course/video-takeover/video-takeover',
    function() {
        return import('modules/the-course/video-takeover/video-takeover');
    },
    true
);